import { render, staticRenderFns } from "./AdminNewClient.vue?vue&type=template&id=67bcf91c"
import script from "./AdminNewClient.vue?vue&type=script&lang=js"
export * from "./AdminNewClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports